const SINGLE_ORDER_MAX_NUM = 1000 // 开放售卖 - 单笔订单最大数量
const configForbiddenAreaBySF = {
    areaId: ['652200'],
    areaName: ['哈密地区']
}

export {
    SINGLE_ORDER_MAX_NUM,
    configForbiddenAreaBySF,
}


// WEBPACK FOOTER //
// ./js/src/common/saleConfig.js